export function getAttribute(key, attributes) {
  const matches = attributes.filter(attr => attr.key === key);

  if (matches.length > 0) {
    return matches[0].value;
  } else {
    return null;
  }
}
